module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/MultipleAlbums-deb4bfb2cf3b7e8a5512825a5947f2fd.jpg";